// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// Importar Bootstrap primero
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Quitar la importación de index.css
// import './index.css';

// Importar global.css al final para que sus estilos tengan prioridad
import './global.css';

import App from './App';
// (si no usas reportWebVitals, puedes quitarlo)
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Si no necesitas reportWebVitals, comenta o bórralo
// reportWebVitals();
